<template>
  <div class="home"></div>
</template>

<script>
export default {
  name: 'Home',
  created () {
    if (this.$u.checkPermissions('user.show')) {
      this.$router.replace({name: 'users'})
    } else {
      this.$router.replace({name: 'profile'})
    }
  }
}
</script>

<style scoped>

</style>
